export default "__VITE_ASSET__Cgx2qw97__"